import { SettingsType } from 'components/organisms/Profile/Settings/ProfileSettings';
import { allSettingsKeys } from 'defs/profile';
import { RootStateType } from './settings';

export const getSettings = (state: RootStateType): SettingsType => {
	return allSettingsKeys
		.map((settingKey: string) => {
			return {
				[settingKey]: (state.profile.userData || {})[settingKey],
			};
		})
		.reduce((previousValue, currentValue) => {
			return {
				...currentValue,
				...(previousValue || {}),
			};
		});
};
